import React from "react";
import PageContainer from "../custom/Page";
import ContractsByHierarchyContext from "./components/Reports/Contract/byHierarchy/ContractsByHierarchyContext";
import { CONTRACT_SITUATIONS, CUSTOMER_ROUTES, HierarchyViewTypeEnum } from "../util";

import HeaderWithHelpDialog from "./components/Reports/Contract/allBelow/HeaderWithHelpDialog";

const defaultParams = { hierarchyViewType: HierarchyViewTypeEnum.ALL };

const ReportContractsAllBelow = () => (
  <PageContainer full>
    <HeaderWithHelpDialog />
    <ContractsByHierarchyContext
      params={defaultParams}
      hierarchyViewType={defaultParams.hierarchyViewType}
      contractSituations={[CONTRACT_SITUATIONS.EXECUTING]}
      customerRoutePrefix={CUSTOMER_ROUTES.MANAGER}
    />
  </PageContainer>
);

export default ReportContractsAllBelow;
